import * as React from 'react';
import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Paper from '@mui/material/Paper';
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';

// Components
import TestEssentialDetails from './TestEssentialDetails';
import TestResultsDetails from './TestResultsDetails';
import TestContentDetails from './TestContentDetails';
import TestSocialDetails from './TestSocialDetails';
import TestVariationDetails from './TestVariationDetails';
import TestSignificanceTest from './TestSignificanceTest';
import TestDelete from './TestDelete';

const SectionCard = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(3),
  marginBottom: theme.spacing(3),
  borderRadius: theme.shape.borderRadius,
  border: '1px solid color-mix(in srgb, #e07136 38%, var(--color-border))',
  background: 'color-mix(in srgb, var(--color-surface) 86%, #e07136 14%)',
  boxShadow: theme.shadows[3],
  transition: 'box-shadow 0.3s ease, transform 0.2s ease',
  '&:hover': {
    boxShadow: theme.shadows[5],
    transform: 'translateY(-1px)',
  },
}));

const SectionTitle = styled(Typography)(({ theme }) => ({
  marginTop: theme.spacing(2),
  marginBottom: theme.spacing(3),
  paddingBottom: theme.spacing(1),
  borderBottom: '1px solid color-mix(in srgb, #e07136 42%, var(--color-border))',
  fontWeight: 600,
  color: 'color-mix(in srgb, var(--color-text) 82%, #e07136 18%)',
}));

export default function EditTest({ testDoc, testId }) {
  return (
    <Box sx={{ flexGrow: 1 }}>
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <SectionCard>
            <SectionTitle variant="h5">Test Core Details</SectionTitle>
            <TestEssentialDetails />
            <SectionTitle variant="h5">Performance Metrics</SectionTitle>
            <TestSocialDetails />
            <SectionTitle variant="h5">Statistical Significance</SectionTitle>
            <TestSignificanceTest />
            <SectionTitle variant="h5">Detailed Results</SectionTitle>
            <TestResultsDetails />
            <SectionTitle variant="h5">Variation Analysis</SectionTitle>
            <TestVariationDetails />
            <SectionTitle variant="h5">Content Details</SectionTitle>
            <TestContentDetails />
          </SectionCard>
        </Grid>



        <Grid item xs={12}>
          <SectionCard>
            <TestDelete testDoc={testDoc} testId={testId} />
          </SectionCard>
        </Grid>
      </Grid>
    </Box>
  );
}
